export default "__VITE_ASSET__CqwBMQ$b__"